import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type ListItemStyledPropT = {
  isSelected?: boolean;
};
export const getPopupContentStyle = (isMobile: boolean): Record<string, string> => ({
  width: '100%',
  maxWidth: isMobile ? 'none' : '700px',
  height: isMobile ? '100%' : 'auto',
  maxHeight: isMobile ? 'none' : '700px',
  padding: '1.5rem 1rem 1.375rem',
  overflowY: 'auto',
});

export const ListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  min-height: 400px;
  margin: 0 0 1rem 0;
  background-color: ${({ theme }): string => theme.colors.surface};
`;

export const ListItemStyled = styled.li<ListItemStyledPropT>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.25rem 0.5rem;
  padding: 0.25rem 0 0.25rem 0.5rem;
  background: ${({ theme, isSelected }): string =>
    isSelected ? theme.colors.secondary.variant3 : theme.colors.primary.variant3};
  border-radius: ${({ theme }): string => theme.radius.xs};

  &:first-of-type {
    margin-top: 0.5rem;
  }
  &:last-of-type {
    margin-bottom: 0.5rem;
  }

  ${({ theme }): string => `
    ${theme.devices.tablet} {
      padding: 0.75rem 0 0.75rem 0.5rem;
    }
  `}
`;

export const ListItemTopRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex-wrap: wrap;
`;

export const ListItemMetaFieldStyled = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 5rem;
`;

export const ListItemMetaFieldTypeStyled = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 2.5rem;
  max-width: 3rem;
  overflow: hidden;

  & > *:last-child,
  & > *:last-child > * {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ListItemActionsRowStyled = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-wrap: nowrap;
  min-width: 0;
`;

export const ListItemMetaFieldsStyled = styled.span`
  display: flex;
  gap: 1.25rem;
  align-items: flex-start;
  margin-left: 0.5rem;
  flex-shrink: 0;
`;

export const AttachmentNameStyled = styled(Typography)`
  flex: 1;
  min-width: 0;
  font-size: ${({ theme }): string => theme.fontSize.md};
  font-weight: ${({ theme }): string => theme.fontWeight.bold.toString()};
  color: ${({ theme }): string => theme.colors.primary.variant11};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${({ theme }): string => `
    ${theme.devices.mobile} {
      max-width: 160px;
    }
  `}

  ${({ theme }): string => `
    ${theme.devices.tablet} {
      max-width: 200px;
    }
  `}
`;

export const LabelStyled = styled(Typography)`
  color: ${({ theme }): string => theme.colors.primary.variant8};
  font-size: ${({ theme }): string => theme.fontSize.xs};
`;

export const ValueStyled = styled(Typography)`
  font-size: ${({ theme }): string => theme.fontSize.xs};
  font-weight: ${({ theme }): string => theme.fontWeight.semibold.toString()};
`;

export const BtnStyled = styled(Button)`
  font-size: ${({ theme }): string => theme.fontSize.sm};
  font-weight: ${({ theme }): string => theme.fontWeight.bold.toString()};

  &:disabled {
    opacity: 1;
  }

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }): string => theme.colors.secondary.variant5};
    }
  }
`;

export const FlexStyled = styled(FlexContainer)`
  height: 100%;

  ${({ theme }): string => `
    ${theme.devices.tablet} {
      height: 354px;
    }
    `}
`;
